import { VCard } from 'vuetify/lib/components/VCard';
import { VResponsive } from 'vuetify/lib/components/VResponsive';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VResponsive,{attrs:{"aspect-ratio":1}},[_c(VCard,{directives:[{name:"show",rawName:"v-show",value:(_vm.calories_total),expression:"calories_total"}],staticClass:"example pa-12",staticStyle:{"height":"100%"},attrs:{"flat":""}},[_c('div',{staticClass:"v-card-border pa-6",staticStyle:{"height":"100%"}},[_c('canvas',{ref:"plot",staticStyle:{"height":"100%"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }